/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/es.js'

import iconSet from 'quasar/icon-set/eva-icons.js'



import {QSpinnerTail,Notify,Loading,Meta,LocalStorage} from 'quasar'



const userOptions = { config: {"loading":{"spinner":"QSpinnerTail"}},lang,iconSet,components: {QSpinnerTail},plugins: {Notify,Loading,Meta,LocalStorage} }
  
userOptions.config.loading.spinner = QSpinnerTail
  
  
export default userOptions

